import { Head, usePage } from '@inertiajs/react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

type SharedProps = {
  current_user?: {
    id: number
    code?: string
    email: string
    firstName?: string
    lastName?: string
    role?: string
    status?: string
  }
}

export default function InertiaExample() {
  const { current_user } = usePage<SharedProps>().props

  return (
    <div className="mx-auto w-full max-w-3xl px-8 pt-8">
      <Head title="Ruby on Rails + Inertia + React" />
      <Card>
        <CardHeader>
          <CardTitle>Current user</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {current_user ? (
            <>
              <div>
                <span className="text-muted-foreground">Name:</span>{' '}
                {[current_user.firstName, current_user.lastName]
                  .filter(Boolean)
                  .join(' ') || '-'}
              </div>
              <div>
                <span className="text-muted-foreground">Email:</span>{' '}
                {current_user.email}
              </div>
              <div>
                <span className="text-muted-foreground">Role:</span>{' '}
                <Badge variant="secondary">{current_user.role || '-'}</Badge>
              </div>
              <div>
                <span className="text-muted-foreground">Status:</span>{' '}
                <Badge variant="outline">{current_user.status || '-'}</Badge>
              </div>
            </>
          ) : (
            <div className="text-muted-foreground">No user signed in.</div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
